/**
 * Sidebar Icon
 *
 */

export default function logo(props = {}) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.33333 19.1482L2 24.1898L9.33333 29.2315"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6667 29.2315L46 24.1898L38.6667 19.1482"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4214 28.7549L23.4198 24.2664"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4202 24.2664C24.3322 24.6724 25.4054 24.2518 25.8173 23.3268C26.2291 22.4018 25.8236 21.3228 24.9116 20.9167C23.9995 20.5106 22.9263 20.9313 22.5145 21.8563C22.1027 22.7813 22.5082 23.8603 23.4202 24.2664Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1066 36.3098C19.3051 35.84 30.7972 26.2144 30.7972 26.2144C31.1663 25.8527 31.4561 25.4169 31.6476 24.9358C31.8391 24.4547 31.9278 23.9391 31.9081 23.4231L31.1425 18.0318L22.8857 14.3556L18.3668 17.3942C17.9701 17.7248 17.6464 18.1357 17.417 18.5999C17.1876 19.0641 17.0577 19.5711 17.0358 20.0874C17.0358 20.0874 17.6538 35.1048 18.1066 36.3098Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1425 18.0318L22.8857 14.3556L23.0922 10.0726C23.0462 9.90565 23.0485 9.72841 23.0987 9.56166C23.1488 9.39491 23.2449 9.24555 23.3756 9.13108C23.5063 9.0166 23.6662 8.94174 23.8366 8.91526C24.007 8.88879 24.1809 8.91179 24.3378 8.98159L34.246 13.393C34.4029 13.4629 34.5363 13.5767 34.6306 13.7211C34.725 13.8654 34.7764 14.0343 34.7787 14.2081C34.7811 14.3818 34.7344 14.5531 34.6441 14.702C34.5537 14.8509 34.4235 14.9712 34.2687 15.0487L31.1425 18.0318Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
